import React from "react";
import styled from "styled-components";

const Select = styled.select`
  border-radius: 2px;
  height: 3rem;
  padding: 0.5rem;
  border: 1px solid #dcdcdc;
  display: block;
  width: 100%;
  box-sizing: border-box;
  &:focus {
    border-color: #c7c7c7;
  }
  ${({ isInvalid }) =>
    isInvalid &&
    `
    border-color: #E7040F;
  `};
`;

export default ({ ...props }) => <Select {...props} />;



// WEBPACK FOOTER //
// ./src/components/generic/form/native/Select/index.js